import React from "react"

import { KlaviyoEmbedInterface } from "./KlaviyoEmbed.interface"
import * as s from "./KlaviyoEmbed.module.scss"

export const KlaviyoEmbed = ({ data }: KlaviyoEmbedInterface) => {
  return (
    <div className={s.klaviyoEmbed} id="klaviyoForm">
      <div className={`klaviyo-form-${data.klaviyoId}`}></div>
    </div>
  )
}
